import React, { useEffect } from 'react';
import VideoPlayer from './player/Player';
import { useVideoContext } from '../../../store/videoContext';
import IVideoState from '../../../models/State.interface';
import { IVideoDetail } from '../../../models/Video.interface';

function Dialog(props: {
    setVideoDetailDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element | null {
    const { video, setVideo }: IVideoState = useVideoContext();

    //바디 스크롤을 막는다
    useEffect(() => {
        document.body.setAttribute('style', 'overflow:hidden');
        return () => document.body.setAttribute('style', 'overflow:auto');
    }, []);

    if (!video) return null;
    if (!(video.video_list_no > -1)) return null;

    return (
        <div className="LUX_basic_dialog">
            <div className="dimmed" />
            <div className="dialog_wrap_tbl">
                <div className="dialog_wrap_tblcel">
                    <div
                        className="dialog_wrap"
                        style={{
                            overflow: 'visible',
                            padding: 0,
                            border: 0,
                            background: 'none',
                            height: 'auto',
                        }}
                    >
                        
                        <div className="dialog_content">
                            <VideoPlayer {...video} />
                            <div className="dialog_data">
                                <button
                                    type="button"
                                    className="ex_close_btn"
                                    onClick={() => {
                                        setVideo({} as IVideoDetail);
                                        props.setVideoDetailDialogOpen(false);
                                    }}
                                >
                                    <span className="sp_evg">닫기</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dialog;
